module.exports = __webpack_public_path__ + "img/1.e57d9e20.jpg";